<template>
	<div class="calculator__graph">
		<h3 v-if="title" class="calculator__graph-title">{{ title }}</h3>

		<div class="calculator__graph-content">
			<div class="calculator__graph-svg-wrapper">
				<svg viewBox="0 0 32 32" class="calculator__graph-svg">
					<transition-group name="circle">
						<circle
							v-for="slice in slices"
							:key="slice.key"
							r="16"
							cx="16"
							cy="16"
							class="calculator__graph-circle"
							:stroke-dasharray="`${slice.value} 100`"
							:stroke="slice.color"
							:style="`
								transform: rotate(${(slice.shift / 100) * 360}deg);
								${skipAnimation ? `transition: none;` : ''}
							`"
						/>
					</transition-group>
					<circle
						r="8"
						cx="16"
						cy="16"
						class="calculator__graph-circle calculator__graph-circle--overlay"
					/>
				</svg>
			</div>

			<GraphLegend :shares="shares" />
		</div>
	</div>
</template>

<script>
import { flatten } from '../utils/helpers';
import GraphLegend from './GraphLegend';

export default {
	name: 'Graph',
	components: { GraphLegend },
	props: {
		shares: Array,
		title: String,
		skipAnimation: Boolean
	},
	computed: {
		slices() {
			// Flatten nested shares
			const flattenedShares = flatten(this.shares);

			// Color and shift them
			const slices = flattenedShares.map((slice, i, slices) => {
				const shift = slices.slice(0, i).reduce((acc, prevPiece) => {
					acc += prevPiece.value;

					return acc;
				}, 0);
				const finalizedSlice = {
					...slice,
					shift
				};

				return finalizedSlice;
			});

			// Optimize shift for minimizing items
			// TODO: Figure out edge-cases and insertion (see CSS animation)
			const shiftedSlices = slices.map((slice, i) => {
				if (slice.value === 0) {
					const maxShift = Math.max(
						slice.shift,
						slices[i - 1] ? slices[i - 1].value : slice.shift,
						slices[i] ? slices[i].value : slice.shift
					);

					slice.shift = maxShift;
				}

				return slice;
			});

			return shiftedSlices;
		}
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__graph-title {
	font-size: 1em;
	font-weight: bold;
	margin: 0 0 20px 0;
}

.calculator__graph-svg-wrapper {
	position: relative;
	overflow: hidden;
	flex: 0 0 7.8125rem;
	width: 7.8125rem;
	height: 7.8125rem;
	border-radius: 50%;
	margin-right: 2.5rem;
	margin-bottom: 24px;
}

.calculator__graph-svg {
	transform: rotate(-90deg);
}

.calculator__graph-circle {
	fill: none;
	stroke-width: 32;
	transform-origin: center;
	transition: stroke-dasharray 0.5s ease-in-out, transform 0.5s ease-in-out;
	animation: circle 0.5s ease-in-out;
}
.calculator__graph-circle--overlay {
	fill: var(--color-background-dark);
}

/* Animation */
@keyframes circle {
	from {
		stroke-dasharray: 0 100;
	}
}

/* Desktop */
@media (min-width: 64rem) {
}

/* Desktop wide */
@media (min-width: 90rem) {
	.calculator__graph-content {
		display: flex;
		flex-wrap: wrap;
	}

	.calculator__graph-content .calculator__graphlegend {
		flex: 1;
	}
}
</style>
